import { informacoesModalRegularizacaoErroStyles } from './InformacoesModalRegularizacaoErro.style'

export function informacoesModalRegularizacaoErroIO() {
  return {
    styles: informacoesModalRegularizacaoErroStyles
  }
}

export type InformacoesModalRegularizacaoErroIO = ReturnType<typeof informacoesModalRegularizacaoErroIO>
